import PageSeo from '@/components/feature/PageSeo';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import BackToTop from '@/components/feature/BackToTop';
import ScrollToTop from '@/components/feature/ScrollToTop';
import NewsletterSubscribe from '@/components/feature/NewsletterSubscribe';
import HeroSection from './components/HeroSection';
import HotRanking from './components/HotRanking';
import ChannelGrid from './components/ChannelGrid';
import ContentStream from './components/ContentStream';
import BingeZone from './components/BingeZone';
import FaqSection from './components/FaqSection';
import ReviewsSection from './components/ReviewsSection';
import { faqs, site } from '@/mocks/site';

const homeJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: site.name,
    url: 'https://renrenmingxiao.cn/',
    description: site.description,
    inLanguage: 'zh-CN',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://renrenmingxiao.cn/?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: site.name,
    url: 'https://renrenmingxiao.cn/',
    email: site.email,
    description: site.description,
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.a,
      },
    })),
  },
];

export default function Home() {
  return (
    <>
      <PageSeo
        title="糖心吃瓜网 - 糖心吃瓜下饭解闷 摸鱼笑料与喷饭合集"
        description="糖心吃瓜网集合糖心吃瓜下饭、解闷、摸鱼必备笑料，热点瓜、沙雕图、段子与短视频一网打尽，饭点随手点开一条就能喷饭，专治无聊空虚。"
        keywords="糖心吃瓜,糖心吃瓜网,糖心吃瓜下饭,摸鱼笑料,喷饭合集"
        canonical="https://renrenmingxiao.cn/"
        jsonLd={homeJsonLd}
      />
      <ScrollToTop />
      <SiteHeader />
      <main>
        <HeroSection />
        <HotRanking />
        <ChannelGrid />
        <ContentStream />
        <BingeZone />
        <FaqSection />
        <ReviewsSection />
        <NewsletterSubscribe />
      </main>
      <SiteFooter />
      <BackToTop />
    </>
  );
}